import API from './../api';

export default {

    namespaced: true,

    state() {
        return {
            categories: [],
            partners: [],
            categoryIds: [],
            partnerIds: [],
        };
    },

    getters: {
        categories: (state) => state.categories,
        categoryIds: (state) => state.categoryIds,
        partnerIds: (state) => state.partnerIds,
        categoryById: (state) => (id) => state.categories.find(item => item.id === id),
        partnerById: (state) => (id) => state.partners.find(item => item.id === id),
        categoryNameById: (state, getters) => (id) => {
            const category = getters.categoryById(id);
            return category ? category.name : '';
        },
        partnerTitleById: (state, getters) => (id) => {
            const partner = getters.partnerById(id);
            return partner ? partner.title : '';
        },
    },

    mutations: {
        gotCategories(state, response) {
            state.categories = response.data || [];
            const categoryIds = [];
            const categories = state.categories;
            const len = categories.length;
            for (let i = 0; i < len; i++) {
                categoryIds.push(categories[i].id)
            }
            state.categoryIds = categoryIds;
        },
        gotPartners(state, response) {
            state.partners = response.data || [];
            const partnerIds = [];
            const partners = state.partners;
            const len = partners.length;
            for (let i = 0; i < len; i++) {
                partnerIds.push(partners[i].id)
            }
            state.partnerIds = partnerIds;
        },
    },

    actions: {
        async fetchPartnerCategories({commit}) {
            commit('gotCategories', await API.get('/app/partner-cards/category/'));
        },
        async fetchPartners({commit}) {
            commit('gotPartners', await API.get('/app/partner-cards/info/'))
        }
    },

};